export const checkStatus = (response) => {
  if (!response.ok) {
    // status in the range 200-299 or not
    return Promise.reject(response.json())
  }

  return response
}

export const parseJSON = (response) => response.json()

export const parseError = (error) =>
  error.then((errr) => {
    throw errr
  })

export default (url, options) => fetch(url, options).then(checkStatus).then(parseJSON).catch(parseError)
